// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2ZpDX","label":"Labeled_label__BucRf","divider":"Labeled_divider__2-pjM"};